import angular, { IRootScopeService } from 'angular';

const wrap = /* @ngInject */ (
	/** @type {IRootScopeService} */ $rootScope,
) => async (/** @type {WrapService.Fn} */ callback) => {
	const result = await callback();
	$rootScope.$evalAsync(() => result);
	return result;
};

angular.module('app')
	.service('$wrap', wrap);
